module.exports = {"apiUrl":"https://gw.mutual.club/v1"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 354
// module chunks = 0